import { BrowserRouter, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "../src/App.css";
import AppRouter from "./router/Approuter";
import Header from "./layout/Header";
import Footer from "./layout/Footer/Footer";
import "bootstrap/dist/css/bootstrap.min.css";

// Wrapper component to use useLocation and manage language
const AppContent = () => {
  const location = useLocation();
  const hideLayout = location.pathname.includes("/profile");
  
  // Language state management with localStorage persistence
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    // Get language from localStorage on initial load
    return localStorage.getItem('selectedLanguage') || 'en';
  });

  // Sync with localStorage whenever language changes
  useEffect(() => {
    localStorage.setItem('selectedLanguage', currentLanguage);
  }, [currentLanguage]);

  const handleLanguageChange = (lang) => {
    setCurrentLanguage(lang);
  };

  return (
    <>
      {!hideLayout && (
        <Header 
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
        />
      )}
      <AppRouter currentLanguage={currentLanguage} />
      {!hideLayout && <Footer currentLanguage={currentLanguage} />}
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;